export default __webpack_public_path__ + "static/media/sponsor-dignity.b3c679b8.png";